(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderManager {
    constructor() {
      this.header = document.querySelector('.section-header');
      if (!this.header) return;

      this.headerElement = this.header.querySelector('header');
      if (!this.headerElement) return;

      this.headerElementRight = this.headerElement.querySelector('.header__right .header__menu');
      if (this.headerElementRight) {
      this.headerElementRight = this.headerElement.querySelector('.header__right');
      }
      
      if (!this.header || !this.headerElement) return;
      
      this.scrollUpElement = this.header.querySelector('.sticky-header--scroll-up');
      this.lastScrollY = window.scrollY;

      const computedStyle = window.getComputedStyle(this.header);
      this.isSticky = computedStyle.position === 'sticky' || computedStyle.position === 'fixed';
      
      this.initializeHeightTracking();
      this.updateViewportHeight();
    }

    initializeHeightTracking() {
      this.resizeObserver = new ResizeObserver(([entry]) => {
        if (!entry) return;
        
        this.calculateAndSetHeights();
      });
      
      this.resizeObserver.observe(this.headerElement);
      
      if (this.header !== this.headerElement) {
        this.resizeObserver.observe(this.header);
      }
      
      this.calculateAndSetHeights();
      
      this.handleScroll = this.throttle(() => {
        this.updateStickyState();
      }, 16);
      
      window.addEventListener('scroll', this.handleScroll);
    }

    calculateAndSetHeights() {
      if (!this.headerElement) return;
      
      const headerHeight = this.headerElement.offsetHeight;
      const headerWidth = this.headerElement.offsetWidth;
      const headerTopPosition = this.headerElement.getBoundingClientRect().top;
      const headerBottomPositionRaw = this.headerElement.getBoundingClientRect().bottom;
      const headerBottomPosition = Math.max(0, headerBottomPositionRaw);
      
      document.body.style.setProperty('--header-height', `${headerHeight}px`);
      document.body.style.setProperty('--header-width-js', `${headerWidth}px`);
      if (this.headerElementRight) {
        document.body.style.setProperty('--header-width-menu-js', `${this.headerElementRight.offsetWidth}px`);
      }
      document.body.style.setProperty('--header-top-position', `${headerTopPosition}px`);
      document.body.style.setProperty('--header-bottom-position', `${headerBottomPosition}px`);
    }

    updateViewportHeight() {
      const vh = window.innerHeight;
      document.body.style.setProperty('--viewport-height', `${vh}px`);
    }

    updateStickyState() {
      if (this.header && this.isSticky) {
        this.calculateAndSetHeights();
      }
      this.updateScrollDirection();
    }

    updateScrollDirection() {
      if (!this.scrollUpElement) return;

      const currentScrollY = window.scrollY;
      if (currentScrollY < this.lastScrollY) {
        this.scrollUpElement.classList.add('sroll-top');
      } else if (currentScrollY > this.lastScrollY) {
        this.scrollUpElement.classList.remove('sroll-top');
      }

      this.lastScrollY = currentScrollY;
    }

    throttle(func, limit) {
      let inThrottle;
      return function() {
        const args = arguments;
        const context = this;
        if (!inThrottle) {
          func.apply(context, args);
          inThrottle = true;
          setTimeout(() => inThrottle = false, limit);
        }
      }
    }

    handleResize = () => {
      this.updateViewportHeight();
    }

    destroy() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
      if (this.handleScroll) {
        window.removeEventListener('scroll', this.handleScroll);
      }
      window.removeEventListener('resize', this.handleResize);
      
      document.body.style.removeProperty('--header-height');
      document.body.style.removeProperty('--header-width-js');
      if (this.headerElementRight) {
      document.body.style.removeProperty('--header-width-menu-js');
      }
      document.body.style.removeProperty('--header-bottom-position');
      document.body.style.removeProperty('--viewport-height');
    }
  }

  let headerManagerInstance;

  class HeaderNotificationManager {
    constructor() {
      this.notification = document.querySelector('.header-popup--index');
      this.notificationImage = this.notification ? this.notification.querySelector('.header-popup__icon img') : null;
      this.scrollTimeout = null;
      this.removeClassTimeout = null;
      this.resizeHandler = null;
      this.initializeNotifications();
      this.setupScrollHandler();
    }

    getFocusableElements(container) {
      if (!container) {
        return [];
      }

      return container.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]');
    }

    setFeedAccessibility(notification, isOpen) {
      const feedWrapper = notification.querySelector('.header-popup__feed-wrapper');
      const feedButton = notification.querySelector('.button-open-feed');
      if (!feedWrapper) {
        return;
      }

      feedWrapper.setAttribute('aria-hidden', String(!isOpen));
      if (isOpen) {
        feedWrapper.removeAttribute('inert');
      } else {
        feedWrapper.setAttribute('inert', '');
      }

      this.getFocusableElements(feedWrapper).forEach((element) => {
        if (isOpen) {
          if (element.hasAttribute('data-prev-tabindex')) {
            const previousTabIndex = element.getAttribute('data-prev-tabindex');
            if (previousTabIndex === '') {
              element.removeAttribute('tabindex');
            } else {
              element.setAttribute('tabindex', previousTabIndex);
            }
            element.removeAttribute('data-prev-tabindex');
          }
        } else if (!element.hasAttribute('data-prev-tabindex')) {
          const currentTabIndex = element.getAttribute('tabindex');
          element.setAttribute('data-prev-tabindex', currentTabIndex === null ? '' : currentTabIndex);
          element.setAttribute('tabindex', '-1');
        }
      });

      if (feedButton) {
        feedButton.setAttribute('aria-expanded', String(isOpen));
      }
    }

    initializeNotifications() {
      const notification = this.notification;
      if (!notification) {
        return;
      }

      const notificationId = notification.dataset.notificationId;
      const isDismissible = notification.dataset.dismissible === 'true';

      if (isDismissible && this.isDismissed(notificationId)) {
        return;
      }

      this.setFeedAccessibility(notification, notification.classList.contains('feed-open'));

      notification.style.display = 'block';
      requestAnimationFrame(() => this.setPopupHeight());

      const updateHeight = () => {
        this.setPopupHeight();
      };
      window.addEventListener('resize', updateHeight);
      this.resizeHandler = updateHeight;

      const closeButton = notification.querySelector('.header-popup__close-button');
      if (closeButton) {
        closeButton.addEventListener('click', (e) => {
          e.preventDefault();
          this.dismissNotification(notification, notificationId, isDismissible);
        });
      }

      const feedButton = notification.querySelector('.button-open-feed');
      if (feedButton) {
        feedButton.addEventListener('click', (e) => {
          e.preventDefault();
          const willOpen = !notification.classList.contains('feed-open');
          notification.classList.toggle('feed-open', willOpen);
          this.setFeedAccessibility(notification, willOpen);
          requestAnimationFrame(() => {
            if (!notification.classList.contains('feed-open')) {
              this.setPopupHeight();
            } else {
              notification.style.removeProperty('--popup-height');
            }
          });
        });
      }

      const feedCloseButton = notification.querySelector('.feed-popup__close-button');
      if (feedCloseButton) {
        feedCloseButton.addEventListener('click', (e) => {
          e.preventDefault();
          notification.classList.remove('feed-open');
          this.setFeedAccessibility(notification, false);
          if (feedButton) {
            feedButton.focus();
          }
          requestAnimationFrame(() => this.setPopupHeight());
        });
      }
    }

    setPopupHeight() {
      const notification = this.notification;
      const notificationImage = this.notificationImage;
      if (!notification || notification.classList.contains('feed-open')) {
        return;
      }

      const wasScrolling = notification.classList.contains('is-scrolling');
      if (wasScrolling) {
        notification.classList.remove('is-scrolling');
      }

      const height = notification.offsetHeight;
      const imageHeight = notificationImage ? notificationImage.offsetHeight : 0;
      if (imageHeight > 0) {
        notification.style.setProperty('--popup-height', `${(imageHeight + 10)}px`);
      } else if (height > 0) {
        // notification.style.setProperty('--popup-height', `${(height) * 0.1}rem`);
        notification.style.setProperty('--popup-height', `${height}px`);
      }

      if (wasScrolling) {
        notification.classList.add('is-scrolling');
      }
    }

    setupScrollHandler() {
      if (!this.notification) {
        return;
      }

      const SCROLL_THROTTLE_MS = 200;
      const SCROLL_THRESHOLD_PX = 200;
      let lastRun = 0;
      let scrollReferenceY = window.scrollY ?? document.documentElement.scrollTop;

      this.handleScroll = () => {
        const now = performance.now();
        if (lastRun && now - lastRun < SCROLL_THROTTLE_MS) return;
        lastRun = now;
        this.onScroll(scrollReferenceY, SCROLL_THRESHOLD_PX);
      };

      this.setScrollReference = (y) => {
        scrollReferenceY = y;
      };

      window.addEventListener('scroll', this.handleScroll, { passive: true });
    }

    onScroll(scrollReferenceY, scrollThresholdPx) {
      if (!this.notification) {
        return;
      }

      if (this.removeClassTimeout) {
        clearTimeout(this.removeClassTimeout);
        this.removeClassTimeout = null;
      }

      const scrollY = window.scrollY ?? document.documentElement.scrollTop;
      const scrollDelta = Math.abs(scrollY - scrollReferenceY);

      if (this.notification.style.display !== 'none' && scrollDelta >= scrollThresholdPx) {
        this.notification.classList.add('is-scrolling');
      }

      if (this.scrollTimeout) {
        clearTimeout(this.scrollTimeout);
      }

      this.scrollTimeout = setTimeout(() => {
        this.removeClassTimeout = setTimeout(() => {
          if (this.notification) {
            this.notification.classList.remove('is-scrolling');
            if (this.setScrollReference) {
              const y = window.scrollY ?? document.documentElement.scrollTop;
              this.setScrollReference(y);
            }
          }
        }, 300);
      }, 150);
    }

    dismissNotification(notification, notificationId, isDismissible) {
      notification.style.opacity = '0';
      notification.style.transform = 'translateY(-1rem)';
      
      setTimeout(() => {
        notification.style.display = 'none';
      }, 300);

      if (isDismissible) {
        this.markAsDismissed(notificationId);
      }
    }

    isDismissed(notificationId) {
      try {
        const dismissed = sessionStorage.getItem(`notification_dismissed_${notificationId}`);
        return dismissed === 'true';
      } catch (e) {
        return false;
      }
    }

    markAsDismissed(notificationId) {
      try {
        sessionStorage.setItem(`notification_dismissed_${notificationId}`, 'true');
      } catch (e) {
        console.error('Error marking notification as dismissed:', e);
      }
    }

    destroy() {
      if (this.scrollTimeout) {
        clearTimeout(this.scrollTimeout);
        this.scrollTimeout = null;
      }
      if (this.removeClassTimeout) {
        clearTimeout(this.removeClassTimeout);
        this.removeClassTimeout = null;
      }

      if (this.handleScroll) {
        window.removeEventListener('scroll', this.handleScroll);
      }

      if (this.resizeHandler) {
        window.removeEventListener('resize', this.resizeHandler);
        this.resizeHandler = null;
      }
    }
  }

  function applyMobileColorScheme() {
    const mobileMenu = document.getElementById('mobile-menu');
    if (!mobileMenu) return;
    
    const mobileColorScheme = mobileMenu.getAttribute('data-mobile-color-scheme');
    if (!mobileColorScheme) return;
    
    const isMobile = window.innerWidth <= 1024;
    
    const allClasses = Array.from(mobileMenu.classList);
    allClasses.forEach(className => {
      if (className.startsWith('color-')) {
        mobileMenu.classList.remove(className);
      }
    });
    
    const submenus = mobileMenu.querySelectorAll('.header__submenu');
    submenus.forEach(submenu => {
      const desktopColorScheme = submenu.getAttribute('data-desktop-color-scheme');
      
      if (isMobile) {
        const submenuClasses = Array.from(submenu.classList);
        submenuClasses.forEach(className => {
          if (className.startsWith('color-')) {
            submenu.classList.remove(className);
          }
        });
      } else {
        if (desktopColorScheme) {
          const submenuClasses = Array.from(submenu.classList);
          submenuClasses.forEach(className => {
            if (className.startsWith('color-')) {
              submenu.classList.remove(className);
            }
          });
          submenu.classList.add(`color-${desktopColorScheme}`);
        }
      }
    });
    
    if (isMobile) {
      mobileMenu.classList.add(`color-${mobileColorScheme}`);
    }
  }

  function handleMobileColorSchemeResize() {
    applyMobileColorScheme();
  }

  function devicePrefersClick() {
    return window.matchMedia('(hover: none)').matches || window.matchMedia('(pointer: coarse)').matches;
  }

  function checkMenuWrap() {
    if (window.innerWidth < 1025) {
      return;
    }

    const menu = document.querySelector('.header__right .header__menu');
    if (!menu) return;

    const menuItems = Array.from(menu.children).filter(child => 
      child.classList.contains('header__menu-item')
    );
    
    if (menuItems.length === 0) return;

    const positions = menuItems.map(item => item.offsetTop);

    const firstPosition = positions[0];
    const allOnOneLine = positions.every(pos => Math.abs(pos - firstPosition) < 2);

    const wasWrapped = menu.classList.contains('menu-wrapped');
    
    if (allOnOneLine) {
      menu.setAttribute('data-menu-wrap', 'single');
      menu.classList.remove('menu-wrapped');
      menu.classList.add('menu-single-line');
      
      if (wasWrapped) {
        const expandedItems = menu.querySelectorAll('.header__menu-item--parent[data-expanded="true"]');
        expandedItems.forEach(item => {
          item.setAttribute('data-expanded', 'false');
          const triggerLink = item.querySelector(':scope > .header__menu-item-link');
          if (triggerLink) triggerLink.setAttribute('aria-expanded', 'false');
        });
      }
    } else {
      menu.setAttribute('data-menu-wrap', 'multiple');
      menu.classList.remove('menu-single-line');
      menu.classList.add('menu-wrapped');
    }
  }

  let menuWrapResizeTimeout;
  function handleMenuWrapResize() {
    clearTimeout(menuWrapResizeTimeout);
    menuWrapResizeTimeout = setTimeout(() => {
      requestAnimationFrame(() => {
        checkMenuWrap();
        initializeMenuClickHandlers();
      });
    }, 150);
  }

  let menuCloseTimeout = null;
  let menuClickHandler = null;
  let menuMouseLeaveHandler = null;
  let menuMouseEnterHandler = null;
  let documentClickHandler = null;
  let menuKeyDownHandler = null;

  function initializeMenuClickHandlers() {
    if (window.innerWidth < 1025) {
      return;
    }

    const menu = document.querySelector('.header__right .header__menu');
    if (!menu) return;

    if (menuClickHandler) {
      menu.removeEventListener('click', menuClickHandler);
    }
    if (menuMouseLeaveHandler) {
      menu.removeEventListener('mouseleave', menuMouseLeaveHandler);
    }
    if (menuMouseEnterHandler) {
      menu.removeEventListener('mouseenter', menuMouseEnterHandler);
    }
    if (documentClickHandler) {
      document.removeEventListener('click', documentClickHandler);
    }
    if (menuKeyDownHandler) {
      menu.removeEventListener('keydown', menuKeyDownHandler);
    }

    const closeParentItem = (parentItem) => {
      parentItem.setAttribute('data-expanded', 'false');
      const parentLink = parentItem.querySelector(':scope > .header__menu-item-link');
      if (parentLink) {
        parentLink.setAttribute('aria-expanded', 'false');
      }
    };

    const closeSiblingParents = (parentItem) => {
      const siblings = parentItem.parentElement ? parentItem.parentElement.querySelectorAll(':scope > .header__menu-item--parent[data-expanded="true"]') : [];
      siblings.forEach((sibling) => {
        if (sibling !== parentItem) {
          closeParentItem(sibling);
        }
      });
    };

    const setParentExpandedState = (parentItem, shouldExpand) => {
      parentItem.setAttribute('data-expanded', shouldExpand ? 'true' : 'false');
      const triggerLink = parentItem.querySelector(':scope > .header__menu-item-link');
      if (triggerLink) {
        triggerLink.setAttribute('aria-expanded', shouldExpand ? 'true' : 'false');
      }
    };

    menuClickHandler = (e) => {
      const useClickForSubmenu = menu.classList.contains('menu-wrapped') || devicePrefersClick();
      if (!useClickForSubmenu) return;

      const link = e.target.closest('.header__menu-item--parent > .header__menu-item-link');
      if (!link) return;

      const parentItem = link.closest('.header__menu-item--parent');
      if (!parentItem) return;

      e.preventDefault();
      e.stopPropagation();

      closeSiblingParents(parentItem);

      const isExpanded = parentItem.getAttribute('data-expanded') === 'true';
      setParentExpandedState(parentItem, !isExpanded);
    };
    menu.addEventListener('click', menuClickHandler);

    documentClickHandler = (e) => {
      if (!menu) return;

      const clickedInside = menu.contains(e.target);
      if (!clickedInside) {
        const openParents = menu.querySelectorAll('.header__menu-item--parent[data-expanded="true"]');
        openParents.forEach(parent => {
          closeParentItem(parent);
        });
      }
    };
    document.addEventListener('click', documentClickHandler);

    menuKeyDownHandler = (e) => {
      const triggerLink = e.target.closest('.header__menu-item--parent > .header__menu-item-link');
      if (!triggerLink || !menu.contains(triggerLink)) {
        return;
      }

      const parentItem = triggerLink.closest('.header__menu-item--parent');
      if (!parentItem) {
        return;
      }

      const submenu = parentItem.querySelector(':scope > .header__submenu');
      if (!submenu) {
        return;
      }

      const isExpanded = parentItem.getAttribute('data-expanded') === 'true';
      const isToggleKey = e.key === ' ' || e.key === 'Spacebar';

      if (isToggleKey || e.key === 'Enter') {
        e.preventDefault();
        closeSiblingParents(parentItem);
        setParentExpandedState(parentItem, !isExpanded);
        return;
      }

      if (e.key === 'ArrowDown') {
        e.preventDefault();
        closeSiblingParents(parentItem);
        setParentExpandedState(parentItem, true);
        const firstSubmenuLink = submenu.querySelector('.header__menu-item-link');
        if (firstSubmenuLink) {
          firstSubmenuLink.focus();
        }
        return;
      }

      if (e.key === 'Escape' && isExpanded) {
        e.preventDefault();
        setParentExpandedState(parentItem, false);
        triggerLink.focus();
      }
    };
    menu.addEventListener('keydown', menuKeyDownHandler);

    menuMouseLeaveHandler = (e) => {
      if (devicePrefersClick()) return;
      if (!menu.classList.contains('menu-wrapped')) return;
      
      if (menuCloseTimeout) {
        clearTimeout(menuCloseTimeout);
      }
      
      menuCloseTimeout = setTimeout(() => {
        const openParents = menu.querySelectorAll('.header__menu-item--parent[data-expanded="true"]');
        openParents.forEach(parent => {
          const submenu = parent.querySelector('.header__submenu.submenu-level-1');
          if (submenu) {
            const rect = submenu.getBoundingClientRect();
            const mouseX = e.clientX;
            const mouseY = e.clientY;
            
            if (mouseX < rect.left || mouseX > rect.right || 
                mouseY < rect.top || mouseY > rect.bottom) {
              parent.setAttribute('data-expanded', 'false');
              const parentLink = parent.querySelector(':scope > .header__menu-item-link');
              if (parentLink) parentLink.setAttribute('aria-expanded', 'false');
            }
          } else {
            parent.setAttribute('data-expanded', 'false');
            const parentLink = parent.querySelector(':scope > .header__menu-item-link');
            if (parentLink) parentLink.setAttribute('aria-expanded', 'false');
          }
        });
      }, 200);
    };
    menu.addEventListener('mouseleave', menuMouseLeaveHandler);

    menuMouseEnterHandler = () => {
      if (menuCloseTimeout) {
        clearTimeout(menuCloseTimeout);
        menuCloseTimeout = null;
      }
    };
    menu.addEventListener('mouseenter', menuMouseEnterHandler);

    menu.addEventListener('mouseenter', (e) => {
      if (e.target.closest('.header__submenu.submenu-level-1')) {
        if (menuCloseTimeout) {
          clearTimeout(menuCloseTimeout);
          menuCloseTimeout = null;
        }
      }
    }, true);
  }

  function initializeHeaderManager() {
    if (headerManagerInstance && headerManagerInstance.destroy) {
      headerManagerInstance.destroy();
    }
    
    headerManagerInstance = new HeaderManager();
    new HeaderNotificationManager();
    
    window.addEventListener('resize', headerManagerInstance.handleResize);
    window.addEventListener('resize', handleMobileColorSchemeResize);
    window.addEventListener('resize', handleMenuWrapResize);
    
    applyMobileColorScheme();
    checkMenuWrap();
    initializeMenuClickHandlers();
  }

  document.addEventListener('DOMContentLoaded', initializeHeaderManager);
  document.addEventListener('shopify:section:load', initializeHeaderManager);

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(() => {
      requestAnimationFrame(() => {
        setTimeout(checkMenuWrap, 200);
      });
    });
  }

  function delayedMenuWrapCheck() {
    requestAnimationFrame(() => {
      setTimeout(() => {
        checkMenuWrap();
      }, 300);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', delayedMenuWrapCheck);
  } else {
    delayedMenuWrapCheck();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-product-features"] && !Shopify.designMode) return;
  try {
    
  class ProductFeatures extends HTMLElement {
    constructor() {
      super();
      this.items = [];
      this.handleMouseMove = this.handleMouseMove.bind(this);
      this.handleMouseLeave = this.handleMouseLeave.bind(this);
    }

    connectedCallback() {
      this.init();
    }

    disconnectedCallback() {
      this.cleanup();
    }

    init() {
      this.items = Array.from(this.querySelectorAll('.product-features__item.item-hotspot'));
      
      if (this.items.length === 0) return;

      this.items.forEach((item) => {
        item.dataset.baseTranslateX = '-50%';
        item.dataset.baseTranslateY = '-50%';
        
        item.style.transition = 'transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
      });

      const sectionElement = this.closest('.shopify-section');
      if (sectionElement) {
        sectionElement.addEventListener('mousemove', this.handleMouseMove);
        sectionElement.addEventListener('mouseleave', this.handleMouseLeave);
      }
    }

    cleanup() {
      const sectionElement = this.closest('.shopify-section');
      if (sectionElement) {
        sectionElement.removeEventListener('mousemove', this.handleMouseMove);
        sectionElement.removeEventListener('mouseleave', this.handleMouseLeave);
      }
      
      this.items.forEach((item) => {
        const baseX = item.dataset.baseTranslateX;
        const baseY = item.dataset.baseTranslateY;
        item.style.transform = `translate(${baseX}, ${baseY})`;
        item.style.transition = '';
        delete item.dataset.baseTranslateX;
        delete item.dataset.baseTranslateY;
      });
    }

    handleMouseMove(e) {
      const sectionElement = this.closest('.shopify-section');
      if (!sectionElement) return;
      
      const rect = sectionElement.getBoundingClientRect();
      const centerX = rect.left + rect.width / 2;
      const centerY = rect.top + rect.height / 2;
      
      const mouseX = (e.clientX - centerX) / (rect.width / 2);
      const mouseY = (e.clientY - centerY) / (rect.height / 2);
      
      const containerWidth = rect.width;
      const containerHeight = rect.height;
      const baseIntensityX = Math.min(containerWidth * 0.08, 100);
      const baseIntensityY = Math.min(containerHeight * 0.04, 30);
      
      this.items.forEach((item, index) => {
        const itemIntensity = 1 + (index * 0.15);
        const moveX = -(mouseX * itemIntensity * baseIntensityX);
        const moveY = -(mouseY * itemIntensity * baseIntensityY);
        
        const maxMoveX = Math.min(Math.abs(moveX), baseIntensityX);
        const maxMoveY = Math.min(Math.abs(moveY), baseIntensityY);
        const clampedX = moveX < 0 ? -maxMoveX : maxMoveX;
        const clampedY = moveY < 0 ? -maxMoveY : maxMoveY;
        
        const baseX = item.dataset.baseTranslateX;
        const baseY = item.dataset.baseTranslateY;
        item.style.transform = `translate(calc(${baseX} + ${clampedX}px), calc(${baseY} + ${clampedY}px))`;
      });
    }

    handleMouseLeave() {
      this.items.forEach((item) => {
        const baseX = item.dataset.baseTranslateX;
        const baseY = item.dataset.baseTranslateY;
        item.style.transform = `translate(${baseX}, ${baseY})`;
      });
    }
  }

  if (!customElements.get('product-features')) {
    customElements.define('product-features', ProductFeatures);
  }

  document.addEventListener('shopify:section:load', (event) => {
    const featuresElement = event.target.querySelector('product-features');
    if (featuresElement && featuresElement.connectedCallback) {
      featuresElement.connectedCallback();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
